import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractType } from './abstract-type';

@inheritSerialization(AbstractType)
export class ApprovalRequestStatus extends AbstractType {
  @autoserialize
  approvalRequestStatusEnum: string;
}
